import React  from "react"; 
 
 
 
const Header = () => {
   
    
    return (
        <>

            <div className="respo-header">
                <div className="d-flex align-item-center justify-content-center">

                    <a className="navbar-brand" target="_blank" href="/#" title="Syncuppro- Hire the Best Compliance Expert for your needs">
                        <img className="logo" src={window.location.origin + "/images/syncuppro-logo.svg"} alt="syncuppro-logo" />
                    </a>
                </div>


            </div>
            <header className="fixed-top"  >

                <nav id="navbar_main" className={`mobile-offcanvas navbar navbar-expand-lg bg-white`} >
                    <div className="container-fluid p-relative">

                        <a className="navbar-brand" target="_blank" href="/#" title="Syncuppro- Hire the Best Compliance Expert for your needs">
                            <img className="logo" src={window.location.origin + "/images/syncuppro-logo.svg"} alt="syncuppro-logo" />
                        </a>





                    </div>
                </nav>
            </header>

        </>
    );
};
export default Header;